import React from 'react';
import './index.scss';

class SignInBreakDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  render() {
    return (
			<div className="signInBreakDialog">
				<div className="dialog">
					<div className="step">你已断签，需要重新开始签到</div>
					<div className="openBtn">知道了</div>
					<div className="tip">活动3天后结束</div>
				</div>
			</div>
    );
  }
}

export default SignInBreakDialog;
